export const OtaData = [
    {
        "id": 1,
        "image": require("../images/ota/ota_01.webp"),
        "link": "https://www.kkday.com/zh-tw/product/100025?cid=14884&ud1=pixnet01&ud2=eventpage",
        "title": "頑皮世界野生動物園",
        "description": "線上 68 折比現場便宜！",
        "price": "480",
        "type": "kkday"
    },
    {
        "id": 2,
        "image": require("../images/ota/ota_02.webp"),
        "link": "https://www.kkday.com/zh-tw/product/116709?cid=14884&ud1=pixnet02&ud2=eventpage",
        "title": "走馬瀨農場門票",
        "description": "即買即用線上再享 75 折",
        "price": "120 起",
        "type": "kkday"
    },
    {
        "id": 3,
        "image": require("../images/ota/ota_03.webp"),
        "link": "https://www.kkday.com/zh-tw/product/115047?cid=14884&ud1=pixnet03&ud2=eventpage",
        "title": "zero zero 拆車夢工廠",
        "description": "KKday 獨家星際導覽",
        "price": "150 起",
        "type": "kkday"
    },
    {
        "id": 4,
        "image": require("../images/ota/ota_04.webp"),
        "link": "https://www.kkday.com/zh-tw/product/105043?cid=14884&ud1=pixnet04&ud2=eventpage",
        "title": "左鎮化石博物館",
        "description": "親子行程推薦 9 折即買即用",
        "price": "90",
        "type": "kkday"
    },
    {
        "id": 5,
        "image": require("../images/ota/ota_05.webp"),
        "link": "https://www.kkday.com/zh-tw/product/126588?cid=14884&ud1=pixnet05&ud2=eventpage",
        "title": "遊戲愛樂園南紡店",
        "description": "享 87 折！室內兒童遊戲區",
        "price": "308 起",
        "type": "kkday"
    },
    {
        "id": 6,
        "image": require("../images/ota/ota_06.webp"),
        "link": "https://www.kkday.com/zh-tw/product/104779?cid=14884&ud1=pixnet06&ud2=eventpage",
        "title": "山上花園水道博物館",
        "description": "9 折遊日式博物館與花園",
        "price": "90",
        "type": "kkday"
    },
    {
        "id": 7,
        "image": require("../images/ota/ota_07.webp"),
        "link": "https://www.kkday.com/zh-tw/product/104775?cid=14884&ud1=pixnet07&ud2=eventpage",
        "title": "安平樹屋門票",
        "description": "9 折優惠！必訪台南歷史建築",
        "price": "45",
        "type": "kkday"
    },
    {
        "id": 8,
        "image": require("../images/ota/ota_08.webp"),
        "link": "https://www.kkday.com/zh-tw/product/133146?cid=14884&ud1=pixnet08&ud2=eventpage",
        "title": "漫度漁光免搭帳露營",
        "description": "全新免搭帳營區獨家贈釣竿",
        "price": "600 起",
        "type": "kkday"
    },
    {
        "id": 9,
        "image": require("../images/ota/ota_09.webp"),
        "link": "https://www.kkday.com/zh-tw/product/136245?cid=14884&ud1=pixnet09&ud2=eventpage",
        "title": "台南南埕衖事",
        "description": "唯一台南巷弄設計冰淇淋店",
        "price": "530 起",
        "type": "kkday"
    },
    {
        "id": 10,
        "image": require("../images/ota/ota_10.webp"),
        "link": "https://www.kkday.com/zh-tw/product/129253?cid=14884&ud1=pixnet10&ud2=eventpage",
        "title": "台南安平運河遊船",
        "description": "市場最低價！安平遊河導覽",
        "price": "197 起",
        "type": "kkday"
    },
    {
        "id": 11,
        "image": require("../images/ota/ota_11.webp"),
        "link": "https://www.kkday.com/zh-tw/product/119066?cid=14884&ud1=pixnet11&ud2=eventpage",
        "title": "七股潟湖生態遊船",
        "description": "潟湖導覽烤鮮蚵吃到飽",
        "price": "350",
        "type": "kkday"
    },
    {
        "id": 12,
        "image": require("../images/ota/ota_12.webp"),
        "link": "https://www.kkday.com/zh-tw/product/29261?cid=14884&ud1=pixnet12&ud2=eventpage",
        "title": "曾文水庫觀光遊艇",
        "description": "曾文水庫水鄉山城之美",
        "price": "299 起",
        "type": "kkday"
    },
    {
        "id": 13,
        "image": require("../images/ota/ota_13.webp"),
        "link": "https://www.kkday.com/zh-tw/product/128301?cid=14884&ud1=pixnet13&ud2=eventpage",
        "title": "七股潟湖觀光竹筏",
        "description": "台江內海導覽鮮蚵吃到飽",
        "price": "250",
        "type": "kkday"
    },
    {
        "id": 14,
        "image": require("../images/ota/ota_14.webp"),
        "link": "https://www.kkday.com/zh-tw/product/137385?cid=14884&ud1=pixnet14&ud2=eventpage",
        "title": "台南拼車一日遊",
        "description": "十鼓仁糖 & 奇美博物館",
        "price": "899 起",
        "type": "kkday"
    },
    {
        "id": 15,
        "image": require("../images/ota/ota_15.webp"),
        "link": "https://www.kkday.com/zh-tw/product/102395?cid=14884&ud1=pixnet15&ud2=eventpage",
        "title": "南橫公路｜台南出發",
        "description": "台南出發，南橫公路必訪景點",
        "price": "1,599 起",
        "type": "kkday"
    },
    {
        "id": 16,
        "image": require("../images/ota/ota_16.webp"),
        "link": "https://www.kkday.com/zh-tw/product/23351?cid=14884&ud1=pixnet16&ud2=eventpage",
        "title": "古巷速客達 Gogoro 租車",
        "description": "台南火車站旁 Gogoro 租車",
        "price": "398 起",
        "type": "kkday"
    },
    {
        "id": 17,
        "image": require("../images/ota/ota_17.webp"),
        "link": "https://coolprice.com.tw/e-ticket/638/BaOx130h4Zk",
        "title": "台南富驛時尚酒店",
        "description": "時尚雙人房平日一泊一食優惠專案",
        "price": "2,400",
        "type": "cool"
    },
    {
        "id": 18,
        "image": require("../images/ota/ota_18.webp"),
        "link": "https://coolprice.com.tw/e-ticket/641/BaOx130h4Zk",
        "title": "安平留飯店",
        "description": "雅緻雙人房平日一泊一食優惠專案",
        "price": "2,400",
        "type": "cool"
    },
    {
        "id": 19,
        "image": require("../images/ota/ota_19.webp"),
        "link": "https://coolprice.com.tw/e-ticket/644/BaOx130h4Zk",
        "title": "烏山頭湖境渡假會館",
        "description": "雙人客房平日一泊一食優惠專案",
        "price": "2,200",
        "type": "cool"
    },
    // {
    //     "id": 20,
    //     "image": require("../images/ota/ota_20.webp"),
    //     "link": "https://lihi2.cc/tj2sT",
    //     "title": "禧榕軒大飯店",
    //     "description": "經典客房平日一泊一食優惠專案",
    //     "price": "3,700",
    //     "type": "cool"
    // },
    {
        "id": 20,
        "image": require("../images/ota/ota_20_2.webp"),
        "link": "https://coolprice.com.tw/e-ticket/675/BaOx130h4Zk",
        "title": "和逸飯店台南西門館",
        "description": "卡通主題舒適客房平日升等專案",
        "price": "5,999",
        "type": "cool"
    },
    {
        "id": 21,
        "image": require("../images/ota/ota_21.webp"),
        "link": "https://coolprice.com.tw/e-ticket/652/BaOx130h4Zk",
        "title": "徠.歸仁飯店",
        "description": "精緻客房平日一泊一食優惠專案",
        "price": "2,750",
        "type": "cool"
    },
    {
        "id": 22,
        "image": require("../images/ota/ota_22.webp"),
        "link": "https://coolprice.com.tw/e-ticket/660/BaOx130h4Zk",
        "title": "榮美金鬱金香酒店",
        "description": "標準雙人房平日一泊一食升等專案",
        "price": "2,640",
        "type": "cool"
    },
    {
        "id": 23,
        "image": require("../images/ota/ota_23.webp"),
        "link": "https://coolprice.com.tw/e-ticket/655/BaOx130h4Zk",
        "title": "台南桂田酒店",
        "description": "豪華客房平日一泊二食升等專案",
        "price": "7,040",
        "type": "cool"
    },
    {
        "id": 24,
        "image": require("../images/ota/ota_24.webp"),
        "link": "https://coolprice.com.tw/e-ticket/657/BaOx130h4Zk",
        "title": "南科贊美酒店",
        "description": "精緻雙人房平日一泊一食升等專案",
        "price": "3,300",
        "type": "cool"
    },
    {
        "id": 25,
        "image": require("../images/ota/ota_25.webp"),
        "link": "https://coolprice.com.tw/e-ticket/667/BaOx130h4Zk",
        "title": "夏都城旅安平館",
        "description": "漫享家庭房平日一泊一食升等專案",
        "price": "5,475",
        "type": "cool"
    },
    {
        "id": 26,
        "image": require("../images/ota/ota_26.webp"),
        "link": "https://www.taiwantravelmap.com/hotel/651-ch-index.html?cid=pixnet",
        "title": "道達飯店",
        "description": "不只是旅宿，更是在台南的家",
        "price": "1,904 起",
        "type": "readygo"
    },
    {
        "id": 27,
        "image": require("../images/ota/ota_27.webp"),
        "link": "https://www.taiwantravelmap.com/hotel/870-ch-index.html?cid=pixnet",
        "title": "聖旺商旅",
        "description": "漫遊府城，輕旅族的絕佳首選",
        "price": "2,100 起",
        "type": "readygo"
    },
    {
        "id": 28,
        "image": require("../images/ota/ota_28.webp"),
        "link": "https://www.taiwantravelmap.com/hotel/867-ch-index.html?cid=pixnet",
        "title": "聖禾大飯店",
        "description": "享食零距離，感受文化零時差",
        "price": "2,500 起",
        "type": "readygo"
    },
    {
        "id": 29,
        "image": require("../images/ota/ota_29.webp"),
        "link": "https://www.taiwantravelmap.com/hotel/535-ch-index.html?cid=pixnet",
        "title": "夏都富朗酒店",
        "description": "府城古都裡的巴洛克異國享受",
        "price": "2,600 起",
        "type": "readygo"
    },
    {
        "id": 30,
        "image": require("../images/ota/ota_30.webp"),
        "link": "https://www.taiwantravelmap.com/hotel/713-ch-index.html?cid=pixnet",
        "title": "沐雲頂國際商務旅館",
        "description": "在城市中一同享受剎那的永恆",
        "price": "2,080 起",
        "type": "readygo"
    },
    {
        "id": 31,
        "image": require("../images/ota/ota_31.webp"),
        "link": "https://www.taiwantravelmap.com/hotel/974-ch-index.html?cid=pixnet",
        "title": "夏卡爾汽車旅館",
        "description": "感受一場不想回家的好夢體驗",
        "price": "1,580 起",
        "type": "readygo"
    },
    {
        "id": 32,
        "image": require("../images/ota/ota_32.webp"),
        "link": "https://www.taiwantravelmap.com/hotel/530-ch-index.html?cid=pixnet",
        "title": "歐薇汽車旅館",
        "description": "異國情調設計，優雅極致享受",
        "price": "2,280 起",
        "type": "readygo"
    },
    {
        "id": 33,
        "image": require("../images/ota/ota_33.webp"),
        "link": "https://www.taiwantravelmap.com/hotel/975-ch-index.html?cid=pixnet",
        "title": "假日汽車旅館",
        "description": "假日的巧思，只為你精心打造",
        "price": "1,480 起",
        "type": "readygo"
    },
    {
        "id": 34,
        "image": require("../images/ota/ota_34.webp"),
        "link": "https://www.taiwantravelmap.com/hotel/976-ch-index.html?cid=pixnet",
        "title": "凱渥台南館",
        "description": "典雅空間話語，尊榮休憩享受",
        "price": "1,680 起",
        "type": "readygo"
    },
    {
        "id": 35,
        "image": require("../images/ota/ota_35.webp"),
        "link": "https://www.taiwantravelmap.com/hotel/246-ch-index.html?cid=pixnet",
        "title": "皇賓大飯店",
        "description": "交通便捷，最合適不過的首選",
        "price": "1,900 起",
        "type": "readygo"
    },
    {
        "id": 36,
        "image": require("../images/ota/ota_36.webp"),
        "link": "https://coolprice.com.tw/e-ticket/687/BaOx130h4Zk",
        "title": "D組車型連續承租兩日專案",
        "description": "暢遊台南兩日方案",
        "price": "3,599",
        "type": "budget"
    },
    {
        "id": 37,
        "image": require("../images/ota/ota_37.webp"),
        "link": "https://coolprice.com.tw/e-ticket/688/BaOx130h4Zk",
        "title": "G組車型連續承租兩日專案",
        "description": "暢遊台南兩日方案",
        "price": "4,999",
        "type": "budget"
    },
    {
        "id": 38,
        "image": require("../images/ota/ota_38.webp"),
        "link": "https://coolprice.com.tw/e-ticket/689/BaOx130h4Zk",
        "title": "C組車型承租一日專案",
        "description": "暢遊全台一日行租車方案",
        "price": "1,500",
        "type": "budget"
    },
    {
        "id": 39,
        "image": require("../images/ota/ota_39.webp"),
        "link": "https://coolprice.com.tw/e-ticket/690/BaOx130h4Zk",
        "title": "D組車型承租一日專案",
        "description": "暢遊全台一日行租車方案",
        "price": "1,700",
        "type": "budget"
    },
    {
        "id": 40,
        "image": require("../images/ota/ota_40.webp"),
        "link": "https://coolprice.com.tw/e-ticket/691/BaOx130h4Zk",
        "title": "O組車型承租一日專案",
        "description": "暢遊全台一日行租車方案",
        "price": "2,000",
        "type": "budget"
    },
    {
        "id": 41,
        "image": require("../images/ota/ota_41.webp"),
        "link": "https://coolprice.com.tw/e-ticket/692/BaOx130h4Zk",
        "title": "G組車型承租一日專案",
        "description": "暢遊全台一日行租車方案",
        "price": "2,450",
        "type": "budget"
    },
    {
        "id": 42,
        "image": require("../images/ota/ota_42.webp"),
        "link": "https://coolprice.com.tw/e-ticket/693/BaOx130h4Zk",
        "title": "S組車型承租一日專案",
        "description": "暢遊全台一日行租車方案",
        "price": "3,050",
        "type": "budget"
    }
];
